import { FC } from "react";

import { SxProps } from "@mui/material";

import { SongPauseButtonIcon, SongPlayButtonIcon } from "@assets/svg";

import * as Styled from "./styles";

type TPlayButton = {
  isPlaying: boolean;
  onClick: () => void;
  isBigSize?: boolean;
  isSoundExample?: boolean;
  isMobileBottomPlayer?: boolean;
  sx?: SxProps;
};

export const PlayButton: FC<TPlayButton> = ({
  isPlaying,
  onClick,
  isBigSize = false,
  isSoundExample = false,
  isMobileBottomPlayer = false,
  sx,
}) => {
  return (
    <Styled.Button
      onClick={onClick}
      // The button's only content is an icon, so without a label it announces
      // as "button" to a screen reader and cannot be found by name in a test.
      aria-label={isPlaying ? "Pause" : "Play"}
      data-play-button
      $isBigSize={isBigSize}
      $isSoundExample={isSoundExample}
      $isMobileBottomPlayer={isMobileBottomPlayer}
      sx={sx}
    >
      {isPlaying ? <SongPauseButtonIcon height="100%" /> : <SongPlayButtonIcon height="100%" />}
    </Styled.Button>
  );
};
